import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    headerText: {
        color: theme.palette.text.primary,
        fontWeight: 700,
        fontSize: 28,
        letterSpacing: "0.08em",
        margin: 0
    },
    descriptionText: {
        color: theme.palette.text.secondary,
        fontWeight: 400,
        fontSize: 14,
        margin: 0,
        marginTop: -5
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 7
    },
    logo: {
        height: 70,
        width: 70,
        "-webkitFilter": "drop-shadow(2px 2px 2px lightgrey)"
    },
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 14
    },
    divider: {
        marginLeft: 25,
        marginRight: 25,
        background: 'darkgray',
        width: 1
    },
    progress: {
        backgroundColor: theme.palette.secondary.main,
        height: 5
    },
    appbarRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: "100%"
    },
    appbarContentRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        width: "100%"
    },
    searchIcon: {
        color: theme.palette.common.white
    },
    jobProgressSection: {
        minWidth: 150,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: 2,
        marginRight: 40,
        border: "solid white 2px",
        borderRadius: 5,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 8px 8px",
        fontSize: 14
    },
    jobProgressRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: "100%",
        height: "100%"
    },
    jobProgressIndication: {
        width: "100%"
    },
    jobProgressCompletedIcon: {
        color: theme.palette.success.main,
        height: 35,
        width: 35
    }
}));

export {useStyles};